import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LinkMastermodel } from 'src/app/link-master/link-master-model';

@Injectable({
  providedIn: 'root'
})
export class LinkMasterService {

constructor(private _http: HttpClient) { }



getLinkList(): any {
  return this._http.get(environment.APIEndpoint +'api/LinkMaster/GetLinkMasterList')
    .map((res) => res)
    .catch(this._errorHandler);
}
_errorHandler(error: Response) {
  // tslint:disable-next-line: deprecation
  return Observable.throw(error || 'Server Error');
}

addLink(newarray) {
  const url_ = (environment.APIEndpoint+'api/LinkMaster/AddLink');
  const params = new URLSearchParams();
  params.set('newarray', newarray);
  return this._http.post(url_, newarray)
    .map(
      result => {
        console.log(result);
      },
      error => {
        console.log('There was an error: ');
      }
    );
}

updateLink(LinkModel:LinkMastermodel) {

  const url_ = (environment.APIEndpoint+'api/LinkMaster/UpdateLinkMaster');
  return this._http.put(url_, LinkModel)
    .map(
      result => {
        console.log(result);
      },
      error => {
        console.log('There was an error: ');
      }
    );
}

}
